import {
  ACTIVATE_PARTNER_URL,
  ADD_PARTNER_URL,
  APPROVE_PARTNER_URL,
  DEACTIVATE_PARTNER_URL,
  EDIT_PARTNER_URL,
  GET_ACTIVE_PARTNERS,
  GET_LOGGED_IN_PARTNER_DETAILS,
  GET_PARTNER_AGENTS,
  PARTNER_LIST_URL,
  REJECT_PARTNER_URL,
  UPLOAD_PARTNER_PHOTO,
  VIEW_PARTNER_URL,
} from "../../constant";
import { multipartRequest, resourceRequest } from "../calls";

/* -------- PARTNERS ---------- */
export function doFetchPartner(token) {
  const data = {};
  return resourceRequest(token, PARTNER_LIST_URL, data);
}

export function doAddPartner(token, data) {
  return multipartRequest(token, ADD_PARTNER_URL, data);
}

export function doViewPartner(token, data) {
  return resourceRequest(token, VIEW_PARTNER_URL, data);
}

export function doEditPartner(token, data) {
  return multipartRequest(token, EDIT_PARTNER_URL, data);
}

export function doActivatePartner(token, data) {
  return resourceRequest(token, ACTIVATE_PARTNER_URL, data);
}

export function doDeactivatePartner(token, data) {
  return resourceRequest(token, DEACTIVATE_PARTNER_URL, data);
}

export function doApprovePartner(token, data) {
  return resourceRequest(token, APPROVE_PARTNER_URL, data);
}

export function doRejectPartner(token, data) {
  return resourceRequest(token, REJECT_PARTNER_URL, data);
}

export function doGetActivePartners(token, data) {
  return resourceRequest(token, GET_ACTIVE_PARTNERS, data);
}

export function doGetLoggedInPartnerDetails(token, data) {
  return resourceRequest(token, GET_LOGGED_IN_PARTNER_DETAILS, data);
}

export function doUploadPartnerPhoto(token, data) {
  return multipartRequest(token, UPLOAD_PARTNER_PHOTO, data);
}

export function doGetPartnerAgents(token, data) {
  return resourceRequest(token, GET_PARTNER_AGENTS, data);
}
